// extracted by mini-css-extract-plugin
module.exports = {"mt_02":"gebruikersgroepen_mt_02__1DnCQ","modal_footer":"gebruikersgroepen_modal_footer__18ytG"};